const config: any = {
  rowSelection: true,
  fieldControl: false,
  rowSelectionType: 'radio',
  scroll: {y: 350},
  columns: [
    {
      title: '账号ID',
      dataIndex: 'accountId',
      name: 'accountId',
      ellipsis: true,
      width: 200,
    },
    {
      title: '账号名称',
      dataIndex: 'accountName',
      name: 'accountName',
      ellipsis: true,
      width: 200,
    },

    {
      title: '归属公司',
      dataIndex: 'companyName',
      name: 'companyName',
      ellipsis: true,
      width: 140,
    },
    {
      title: '部门',
      dataIndex: 'deptName',
      width: 150,
      ellipsis: true,
      name: 'deptName',
    },
    {
      title: '军种',
      dataIndex: 'channelTypeName',
      width: 150,
      name: 'channelTypeName',
    },
    {
      title: '渠道',
      dataIndex: 'channelName',
      name: 'channelName',
      ellipsis: true,
      width: 360,
    },
  ],
  search: [
    {
      name: 'accountNameKeyword',
      label: '账号名称',
    },
    {
      name: 'channelId',
      label: '渠道筛选',
      itemType: 'custom',
      render: 'treeSelect',
      data: 'channel',
      allowClear: true,
      showSearch: true,
    },
  ],
}

export default config
